(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("VueMap", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["VueMap"] = factory(require("vue"));
	else
		root["VueMap"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = toPixel;
/* harmony export (immutable) */ __webpack_exports__["h"] = toSize;
/* unused harmony export pixelTo */
/* harmony export (immutable) */ __webpack_exports__["f"] = toLngLat;
/* harmony export (immutable) */ __webpack_exports__["c"] = lngLatTo;
/* unused harmony export toBounds */
/* harmony export (immutable) */ __webpack_exports__["a"] = boundsTo;
/* harmony export (immutable) */ __webpack_exports__["e"] = toIcon;
/* harmony export (immutable) */ __webpack_exports__["d"] = toControlPosition;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return commonConvertMap; });
function toPixel(pixel) {
  if (Array.isArray(pixel)) {
    return new google.maps.Point(pixel[0], pixel[1]);
  }
  return pixel;
}

function toSize(size) {
  if (Array.isArray(size)) {
    return new google.maps.Size(size[0], size[1]);
  }
  return size;
}

function pixelTo(pixel) {
  if (Array.isArray(pixel)) return pixel;
  return [pixel.x, pixel.y];
}

function toLngLat(lngLat) {
  if (Array.isArray(lngLat)) {
    return new google.maps.LatLng(lngLat[1], lngLat[0]);
  }
  return lngLat;
}

function lngLatTo(lngLat) {
  if (!lngLat) return;
  if (Array.isArray(lngLat)) return lngLat.slice();
  return [lngLat.lng(), lngLat.lat()];
}

function toBounds(arrs) {
  if (Array.isArray(arrs)) {
    return new google.maps.LatLngBounds(toLngLat(arrs[0]), toLngLat(arrs[1]));
  }
  return arrs;
}

function boundsTo(bounds) {
  return [lngLatTo(bounds.getSouthWest()), lngLatTo(bounds.getNorthEast())];
}

function toIcon(options) {
  var icon = options;
  if (typeof options === 'string') {
    icon = {
      url: options
    };
  } else if (options['image']) {
    var size = options.size,
        imageOffset = options.imageOffset,
        image = options.image,
        imageSize = options.imageSize;

    icon = {
      url: image,
      size: toSize(size),
      origin: toPixel(imageOffset),
      scaledSize: toSize(imageSize)
    };
  }
  return icon;
}

function toControlPosition(val) {
  return google.maps.ControlPosition[val];
}

var commonConvertMap = {
  position: toLngLat,
  offset: toPixel,
  bounds: toBounds,
  LngLat: toLngLat,
  Pixel: toPixel,
  Point: toPixel,
  Size: toSize,
  Bounds: toBounds,
  icon: toIcon,
  ControlPosition: toControlPosition
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uppercamelcase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uppercamelcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uppercamelcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_event_helper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_constant__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      unwatchFns: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$map = this.$map || this.$parent.$map;
    if (this.$map) {
      this.register();
    } else {
      this.$on(__WEBPACK_IMPORTED_MODULE_3__utils_constant__["a" /* default */].MAP_READY_EVENT, function (map) {
        _this.$map = map;
        _this.register();
      });
    }
  },
  destroyed: function destroyed() {
    this.unregisterEvents();
    if (!this.$mapComponent) return;

    this.$mapComponent.setMap && this.$mapComponent.setMap(null);
    this.$mapComponent.close && this.$mapComponent.close();
    if (this.events && this.events.destroyed) {
      this.events.destroyed.call(this, this.$mapComponent, this);
    }

    this.unwatchFns.forEach(function (item) {
      return item();
    });
    this.unwatchFns = [];
  },


  methods: {
    getHandlerFun: function getHandlerFun(prop) {
      if (this.handlers && this.handlers[prop]) {
        return this.handlers[prop];
      }

      return this.$mapComponent['set' + __WEBPACK_IMPORTED_MODULE_0_uppercamelcase___default()(prop)] || this.$mapComponent.setOptions;
    },
    convertProps: function convertProps() {
      var _this2 = this;

      var props = {};
      if (this.$map) props.map = this.$map;
      var _$options$propsData = this.$options.propsData,
          propsData = _$options$propsData === undefined ? {} : _$options$propsData,
          propsRedirect = this.propsRedirect;

      return Object.keys(propsData).reduce(function (res, _key) {
        var key = _key;
        var propsValue = _this2.convertSignalProp(key, _this2[key]);
        if (propsValue === undefined) return res;
        if (propsRedirect && propsRedirect[_key]) key = propsRedirect[key];
        props[key] = propsValue;
        return res;
      }, props);
    },
    convertSignalProp: function convertSignalProp(key, sourceData) {
      var converter = '';
      var type = '';

      if (this.mapTagName) {
        try {
          var name = this.mapTagName;
          var componentConfig = __WEBPACK_IMPORTED_MODULE_4____["default"][name] || '';

          type = componentConfig.props[key].$type;
          converter = __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["b" /* commonConvertMap */][type];
        } catch (e) {}
      }

      if (type && converter) {
        return converter(sourceData);
      } else if (this.converters && this.converters[key]) {
        return this.converters[key].call(this, sourceData);
      } else {
        var convertFn = __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["b" /* commonConvertMap */][key];
        if (convertFn) return convertFn(sourceData);
        return sourceData;
      }
    },
    registerEvents: function registerEvents() {
      var _this3 = this;

      if (!this.$options.propsData) return;
      if (this.$options.propsData.events) {
        var _loop = function _loop(eventName) {
          __WEBPACK_IMPORTED_MODULE_2__utils_event_helper__["a" /* default */].addListener(_this3.$mapComponent, eventName, function (e) {
            _this3.events[eventName].call(_this3, e, _this3);
          });
        };

        for (var eventName in this.events) {
          _loop(eventName);
        }
      }

      if (this.$options.propsData.onceEvents) {
        var _loop2 = function _loop2(eventName) {
          __WEBPACK_IMPORTED_MODULE_2__utils_event_helper__["a" /* default */].addListenerOnce(_this3.$mapComponent, eventName, function (e) {
            _this3.onceEvents[eventName].call(_this3, e, _this3);
          });
        };

        for (var eventName in this.onceEvents) {
          _loop2(eventName);
        }
      }
    },
    unregisterEvents: function unregisterEvents() {
      __WEBPACK_IMPORTED_MODULE_2__utils_event_helper__["a" /* default */].clearListeners(this.$mapComponent);
    },
    setPropWatchers: function setPropWatchers() {
      var _this4 = this;

      var propsRedirect = this.propsRedirect,
          _$options$propsData2 = this.$options.propsData,
          propsData = _$options$propsData2 === undefined ? {} : _$options$propsData2;


      Object.keys(propsData).forEach(function (prop) {
        var handleProp = prop;
        if (propsRedirect && propsRedirect[prop]) handleProp = propsRedirect[prop];
        var handleFun = _this4.getHandlerFun(handleProp);
        if (!handleFun && prop !== 'events') return;

        var unwatch = _this4.$watch(prop, function (nv) {
          if (prop === 'events') {
            _this4.unregisterEvents();
            _this4.registerEvents();
            return;
          }
          if (handleFun && handleFun === _this4.$mapComponent.setOptions) {
            var _handleFun$call;

            return handleFun.call(_this4.$mapComponent, (_handleFun$call = {}, _handleFun$call[handleProp] = _this4.convertSignalProp(prop, nv), _handleFun$call));
          }

          handleFun.call(_this4.$mapComponent, _this4.convertSignalProp(prop, nv));
        });

        _this4.unwatchFns.push(unwatch);
      });
    },
    registerToManager: function registerToManager() {
      var manager = this.mapManager || this.$parent.mapManager;
      if (manager && this.vid !== undefined) {
        manager.setComponent(this.vid, this.$mapComponent);
      }
    },
    initProps: function initProps() {
      var _this5 = this;

      var props = ['zooms', 'bounds'];

      props.forEach(function (propStr) {
        if (_this5[propStr] !== undefined) {
          var handleFun = _this5.getHandlerFun(propStr);
          handleFun && handleFun.call(_this5.$mapComponent, _this5.convertSignalProp(propStr, _this5[propStr]));
        }
      });
    },
    printReactiveProp: function printReactiveProp() {
      var _this6 = this;

      Object.keys(this._props).forEach(function (k) {
        var fn = _this6.$mapComponent['set' + __WEBPACK_IMPORTED_MODULE_0_uppercamelcase___default()(k)];
        if (fn) {
          console.log(_this6.$options.name, k);
        }
      });
    },
    register: function register() {
      var _this7 = this;

      var res = this.__initComponent && this.__initComponent(this.convertProps());
      if (res && res.then) res.then(function (instance) {
        return _this7.registerRest(instance);
      });else this.registerRest(res);
    },
    registerRest: function registerRest(instance) {
      if (!this.$mapComponent && instance) this.$mapComponent = instance;
      this.registerEvents();
      this.initProps();
      this.setPropWatchers();
      this.registerToManager();

      if (this.events && this.events.init) {
        this.events.init.call(this, this.$mapComponent, this);
      }
    },
    $$getInstance: function $$getInstance() {
      return this.$mapComponent;
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initMapApiLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lazyMapApiLoaderInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazy_map_api_loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
var lazyMapApiLoaderInstance = null;


var initMapApiLoader = function initMapApiLoader(config) {
  if (__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$isServer) return;

  if (lazyMapApiLoaderInstance) return;
  if (!lazyMapApiLoaderInstance) lazyMapApiLoaderInstance = new __WEBPACK_IMPORTED_MODULE_0__lazy_map_api_loader__["a" /* default */](config);
  lazyMapApiLoaderInstance.load();
};


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_injected_map_api_instance__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_map_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_marker_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_info_window_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_polyline_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_polygon__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_rectangle_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_circle__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__managers_map_manager__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MapManager", function() { return __WEBPACK_IMPORTED_MODULE_8__managers_map_manager__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initMapApiLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__services_injected_map_api_instance__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lazyMapApiLoaderInstance", function() { return __WEBPACK_IMPORTED_MODULE_0__services_injected_map_api_instance__["b"]; });













var components = [__WEBPACK_IMPORTED_MODULE_1__components_map_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_marker_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_info_window_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_polyline_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_polygon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_rectangle_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_circle__["a" /* default */]];

var VueMap = {
  initMapApiLoader: __WEBPACK_IMPORTED_MODULE_0__services_injected_map_api_instance__["a" /* initMapApiLoader */],
  MapManager: __WEBPACK_IMPORTED_MODULE_8__managers_map_manager__["a" /* default */]
};

VueMap.install = function (Vue) {
  if (VueMap.installed) return;
  Vue.config.optionMergeStrategies.deferredReady = Vue.config.optionMergeStrategies.created;
  components.map(function (_component) {
    Vue.component(_component.name, _component);

    VueMap[_component.name] = _component;
  });
};

var install = function install(Vue) {
  if (install.installed) return;
  VueMap.install(Vue);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["default"] = (VueMap);




/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_guid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constant__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_register_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_injected_map_api_instance__ = __webpack_require__(3);








var TAG = 'VueMap';
var controlPositionValidator = function controlPositionValidator(value) {
  return ['BOTTOM_CENTER', 'BOTTOM_LEFT', 'BOTTOM_RIGHT', 'LEFT_BOTTOM', 'LEFT_CENTER', 'LEFT_TOP', 'RIGHT_BOTTOM', 'RIGHT_CENTER', 'RIGHT_TOP', 'TOP_CENTER', 'TOP_LEFT', 'TOP_RIGHT'].indexOf(value) !== -1;
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: TAG,
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_register_component__["a" /* default */]],
  props: {
    vid: String,
    backgroundColor: String,
    center: [Array, Object],
    clickableIcons: Boolean,
    controlSize: Number,
    disableDefaultUi: Boolean,
    disableDoubleClickZoom: Boolean,
    draggable: Boolean,
    dragEnable: Boolean,
    draggableCursor: String,
    draggingCursor: String,
    fullscreenControl: Boolean,
    fullscreenControlPosition: {
      type: String,
      validator: controlPositionValidator
    },
    fullscreenControlOptions: Object,
    gestureHandling: {
      type: String,
      validator: function validator(value) {
        return ['cooperative', 'greedy', 'none', 'auto'].indexOf(value) !== -1;
      }
    },
    heading: Number,
    keyboardShortcuts: Boolean,
    mapTypeControl: Boolean,
    mapTypeControlOptions: Object,
    mapTypeId: {
      type: String,
      validator: function validator(value) {
        return ['hybrid', 'roadmap', 'satellite', 'terrain'].indexOf(value) !== -1;
      }
    },
    zoom: Number,
    zooms: [Number, Number],
    noClear: Boolean,
    panControl: Boolean,
    panControlOptions: Object,
    restriction: Object,
    rotateControl: Boolean,
    rotateEnable: Boolean,
    rotateControlPosition: {
      type: String,
      validator: controlPositionValidator
    },
    rotateControlOptions: Object,
    scaleControl: Boolean,
    scaleControlOptions: Object,
    scrollwheel: Boolean,
    scrollWheel: Boolean,
    streetView: Object,
    streetViewControl: Boolean,
    styles: Array,
    tilt: Number,
    zoomControl: Boolean,
    zoomEnable: Boolean,
    zoomControlOptions: Object,
    events: Object,
    mapManager: Object,
    bounds: Array
  },

  beforeCreate: function beforeCreate() {
    this._loadPromise = __WEBPACK_IMPORTED_MODULE_4__services_injected_map_api_instance__["b" /* lazyMapApiLoaderInstance */].load();
  },
  data: function data() {
    return {
      mapTagName: TAG,
      propsRedirect: {
        scrollWheel: 'scrollwheel',
        zoomEnable: 'zoomControl',
        dragEnable: 'draggable',
        rotateEnable: 'rotateControl',
        fullscreenControlPosition: 'fullscreenControlOptions',
        rotateControlPosition: 'rotateControlOptions',
        disableDefaultUi: 'disableDefaultUI'
      },
      converters: {
        center: function center(arr) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__["f" /* toLngLat */])(arr);
        },
        fullscreenControlPosition: function fullscreenControlPosition(val) {
          return {
            position: Object(__WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__["d" /* toControlPosition */])(val)
          };
        },
        rotateControlPosition: function rotateControlPosition(val) {
          return {
            position: Object(__WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__["d" /* toControlPosition */])(val)
          };
        }
      },
      handlers: {
        zooms: function zooms(arr) {
          this.setOptions({
            minZoom: arr[0],
            maxZoom: arr[1]
          });
        },
        bounds: function bounds(val) {
          if (val) {
            this.fitBounds(val);
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.createMap();
  },


  methods: {
    createMap: function createMap() {
      var _this = this;

      this._loadPromise.then(function () {
        var mapElement = _this.$el.querySelector('.vue-map');
        var elementID = _this.vid || Object(__WEBPACK_IMPORTED_MODULE_0__utils_guid__["a" /* default */])();
        mapElement.id = elementID;
        var props = _this.convertProps();

        props.clickableIcons = props.clickableIcons || false;
        _this.$map = _this.$mapComponent = new google.maps.Map(mapElement, props);
        if (_this.mapManager) _this.mapManager.setMap(_this.$map);
        _this.$emit(__WEBPACK_IMPORTED_MODULE_1__utils_constant__["a" /* default */].MAP_READY_EVENT, _this.$map);
        _this.$children.forEach(function (component) {
          component.$emit(__WEBPACK_IMPORTED_MODULE_1__utils_constant__["a" /* default */].MAP_READY_EVENT, _this.$map);
        });
      });
    },
    $$getCenter: function $$getCenter() {
      if (!this.$map) return Object(__WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__["c" /* lngLatTo */])(this.center);
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__["c" /* lngLatTo */])(this.$map.getCenter());
    },
    $$getZoom: function $$getZoom() {
      if (!this.$map) return 0;
      return this.$map.getZoom();
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  MAP_READY_EVENT: 'MAP_READY_EVENT'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_register_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueMapMarker',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_register_component__["a" /* default */]],
  props: ['vid', 'position', 'icon', 'animation', 'cursor', 'draggable', 'label', 'visible', 'zIndex', 'opacity', 'offset', 'events', 'clickable'],
  data: function data() {
    return {
      converters: {
        icon: function icon(options) {
          var icon = Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["e" /* toIcon */])(options);
          if (!icon.anchor && this.offset) {
            icon.anchor = Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["g" /* toPixel */])(this.offset);
          }
          return icon;
        }
      },
      handlers: {
        offset: function offset(value) {
          if (value) {
            var icon = this.getIcon();
            icon.anchor = Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["g" /* toPixel */])(value);
            this.setIcon(icon);
          }
        }
      }
    };
  },

  methods: {
    __initComponent: function __initComponent(options) {
      this.$mapComponent = new google.maps.Marker(options);
    },
    $$getPosition: function $$getPosition() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["c" /* lngLatTo */])(this.$mapComponent.getPosition());
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_register_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueMapInfoWindow',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_register_component__["a" /* default */]],
  props: ['vid', 'autoMove', 'offset', 'position', 'zIndex', 'visible', 'events'],
  data: function data() {
    var self = this;
    return {
      listeners: [],
      tmpVm: null,
      propsRedirect: {
        autoMove: 'disableAutoPan',
        offset: 'pixelOffset'
      },
      converters: {
        autoMove: function autoMove(val) {
          return !val;
        },
        offset: function offset(val) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__utils_convert_helper__["h" /* toSize */])(val);
        }
      },
      handlers: {
        visible: function visible(flag) {
          flag === false ? this.close() : this.open(self.$map);
        }
      }
    };
  },
  created: function created() {
    var i18n = this.$i18n;
    this.tmpVm = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
      i18n: i18n,
      data: function data() {
        return {
          node: ''
        };
      },
      render: function render(h) {
        var node = this.node;

        return h('div', { ref: 'node' }, Array.isArray(node) ? node : [node]);
      }
    }).$mount();
  },
  destroyed: function destroyed() {
    this.$mapComponent.close();
    this.tmpVm.$destroy();
  },

  methods: {
    __initComponent: function __initComponent(options) {
      if (this.$slots.default && this.$slots.default.length) {
        options.content = this.tmpVm.$refs.node;
      }

      delete options.map;
      this.$mapComponent = new google.maps.InfoWindow(options);
      this.addInnerEvents();
      if (this.visible !== false) {
        this.$mapComponent.open(this.$map);
      }
    },
    addInnerEvents: function addInnerEvents() {
      var _this = this;

      this.listeners.push(this.$mapComponent.addListener('closeclick', function () {
        _this.$emit('update:visible', false);
      }));
    },
    removeInnerEvents: function removeInnerEvents() {
      this.listeners.forEach(function (listener) {
        google.maps.event.removeListener(listener);
      });
      this.listeners = [];
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeInnerEvents();
  },
  render: function render() {
    var slots = this.$slots.default || [];
    if (slots.length) {
      this.tmpVm.node = slots;
    }
    return null;
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_register_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueMapPolyline',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_register_component__["a" /* default */]],
  props: {
    vid: String,
    clickable: Boolean,
    draggable: Boolean,
    editable: Boolean,
    strokeColor: String,
    strokeOpacity: Number,

    strokePosition: Number,
    strokeWeight: Number,
    visible: Boolean,
    zIndex: Number,

    geodesic: Boolean,
    path: Array,

    icons: Array,
    events: Object
  },
  data: function data() {
    return {
      converters: {
        path: function path(arr) {
          if (arr && arr.length) {
            return arr.map(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["f" /* toLngLat */]);
          }
        }
      }
    };
  },

  methods: {
    __initComponent: function __initComponent(options) {
      this.$mapComponent = new google.maps.Polyline(options);
    },
    $$getPath: function $$getPath() {
      return this.$mapComponent.getPath().getArray().map(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["c" /* lngLatTo */]);
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_register_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueMapPolygon',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_register_component__["a" /* default */]],
  props: {
    vid: String,
    clickable: Boolean,
    draggable: Boolean,
    editable: Boolean,
    fillColor: String,
    fillOpacity: Number,
    strokeColor: String,
    strokeOpacity: Number,

    strokePosition: Number,
    strokeWeight: Number,
    visible: Boolean,
    zIndex: Number,

    path: Array,
    events: Object
  },
  data: function data() {
    return {
      converters: {
        path: function path(arr) {
          if (arr && arr.length) {
            return arr.map(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["f" /* toLngLat */]);
          }
        }
      }
    };
  },

  methods: {
    __initComponent: function __initComponent(options) {
      this.$mapComponent = new google.maps.Polygon(options);
    },
    $$getPath: function $$getPath() {
      return this.$mapComponent.getPath().getArray().map(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["c" /* lngLatTo */]);
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_register_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__ = __webpack_require__(0);




var TAG = 'VueMapRectangle';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: TAG,
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_register_component__["a" /* default */]],
  props: {
    vid: String,
    clickable: Boolean,
    draggable: Boolean,
    editable: Boolean,
    fillColor: String,
    fillOpacity: Number,
    strokeColor: String,
    strokeOpacity: Number,

    strokePosition: Number,
    strokeWeight: Number,
    visible: Boolean,
    zIndex: Number,

    bounds: {
      type: Array,
      $type: 'Bounds'
    },
    events: Object
  },
  data: function data() {
    return {
      mapTagName: TAG
    };
  },

  methods: {
    __initComponent: function __initComponent(options) {
      this.$mapComponent = new google.maps.Rectangle(options);
    },
    $$getBounds: function $$getBounds() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["a" /* boundsTo */])(this.$mapComponent.getBounds());
    },
    $$getCenter: function $$getCenter() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["c" /* lngLatTo */])(this.$mapComponent.getBounds().getCenter());
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_register_component__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__ = __webpack_require__(0);




var TAG = 'VueMapCircle';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: TAG,
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_register_component__["a" /* default */]],
  props: {
    vid: String,
    clickable: Boolean,
    draggable: Boolean,
    editable: Boolean,
    fillColor: String,
    fillOpacity: Number,
    strokeColor: String,
    strokeOpacity: Number,

    strokePosition: Number,
    strokeWeight: Number,
    visible: Boolean,
    zIndex: Number,
    radius: Number,

    center: {
      type: Array,
      $type: 'LngLat'
    },
    events: Object
  },
  data: function data() {
    return {
      mapTagName: TAG
    };
  },

  methods: {
    __initComponent: function __initComponent(options) {
      this.$mapComponent = new google.maps.Circle(options);
    },
    $$getBounds: function $$getBounds() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["a" /* boundsTo */])(this.$mapComponent.getBounds());
    },
    $$getCenter: function $$getCenter() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_convert_helper__["c" /* lngLatTo */])(this.$mapComponent.getCenter());
    },
    $$getRadius: function $$getRadius() {
      return this.$mapComponent.getRadius();
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_MAP_CONFIG = {
  key: null,
  protocol: 'https',
  hostAndPath: 'maps.googleapis.com/maps/api/js',
  callback: 'mapInitComponent',
  language: null,
  region: null
};

var MapAPILoader = function () {
  function MapAPILoader(config) {
    _classCallCheck(this, MapAPILoader);

    this._config = _extends({}, DEFAULT_MAP_CONFIG, config);
    this._document = document;
    this._window = window;
    this._scriptLoaded = false;
  }

  MapAPILoader.prototype.load = function load() {
    var _this = this;

    if (this._window.google && this._window.google.maps && this._window.google.maps.Map) {
      return Promise.resolve();
    }

    if (this._scriptLoadingPromise) return this._scriptLoadingPromise;
    var script = this._document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = this._getScriptSrc();

    this._scriptLoadingPromise = new Promise(function (resolve, reject) {
      _this._window['mapInitComponent'] = function () {
        resolve();
      };
      script.onerror = function (error) {
        return reject(error);
      };
    });
    this._document.head.appendChild(script);
    return this._scriptLoadingPromise;
  };

  MapAPILoader.prototype._getScriptSrc = function _getScriptSrc() {

    var config = this._config;
    var paramKeys = ['key', 'callback', 'language', 'region'];

    var params = Object.keys(config).filter(function (k) {
      return ~paramKeys.indexOf(k);
    }).filter(function (k) {
      return config[k] != null;
    }).filter(function (k) {
      return !Array.isArray(config[k]) || Array.isArray(config[k]) && config[k].length > 0;
    }).map(function (k) {
      var v = config[k];
      if (Array.isArray(v)) return { key: k, value: v.join(',') };
      return { key: k, value: v };
    }).map(function (entry) {
      return entry.key + '=' + entry.value;
    }).join('&');
    return this._config.protocol + '://' + this._config.hostAndPath + '?' + params;
  };

  return MapAPILoader;
}();

/* harmony default export */ __webpack_exports__["a"] = (MapAPILoader);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c57ca3f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(2);
function injectStyle (context) {
  __webpack_require__(17)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c57ca3f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c57ca3f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(18);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("7b04d33a", content, true);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, ".vue-map,.vue-map-container{height:100%}", ""]);

// exports


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(21)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = guid;
function guid() {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';

  var uuid = s.join('');
  return uuid;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var camelCase = __webpack_require__(24);

module.exports = function () {
	var cased = camelCase.apply(camelCase, arguments);
	return cased.charAt(0).toUpperCase() + cased.slice(1);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function () {
	var str = [].map.call(arguments, function (str) {
		return str.trim();
	}).filter(function (str) {
		return str.length;
	}).join('-');

	if (!str.length) {
		return '';
	}

	if (str.length === 1 || !(/[_.\- ]+/).test(str) ) {
		if (str[0] === str[0].toLowerCase() && str.slice(1) !== str.slice(1).toLowerCase()) {
			return str;
		}

		return str.toLowerCase();
	}

	return str
	.replace(/^[_.\- ]+/, '')
	.toLowerCase()
	.replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
		return p1.toUpperCase();
	});
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var eventHelper = void 0;

var EventHelper = function () {
  function EventHelper() {
    _classCallCheck(this, EventHelper);

    this._listener = new Map();
  }

  EventHelper.prototype.addListener = function addListener(instance, eventName, handler, context) {
    if (!google.maps.event) throw new Error('please wait for Map API load');
    var listener = google.maps.event.addListener(instance, eventName, handler, context);
    if (!this._listener.get(instance)) this._listener.set(instance, {});
    var listenerMap = this._listener.get(instance);
    if (!listenerMap[eventName]) listenerMap[eventName] = [];
    listenerMap[eventName].push(listener);
  };

  EventHelper.prototype.removeListener = function removeListener(instance, eventName, handler) {
    if (!google.maps.event) throw new Error('please wait for Map API load');
    if (!this._listener.get(instance) || !this._listener.get(instance)[eventName]) return;
    var listenerArr = this._listener.get(instance)[eventName];
    if (handler) {
      var l_index = listenerArr.indexOf(handler);
      google.maps.event.removeListener(listenerArr[l_index]);
      listenerArr.splice(l_index, 1);
    } else {
      listenerArr.forEach(function (listener) {
        google.maps.event.removeListener(listener);
      });
      this._listener.get(instance)[eventName] = [];
    }
  };

  EventHelper.prototype.addListenerOnce = function addListenerOnce(instance, eventName, handler, context) {
    return google.maps.event.addListenerOnce(instance, eventName, handler, context);
  };

  EventHelper.prototype.trigger = function trigger(instance, eventName, args) {
    return google.maps.event.trigger(instance, eventName, args);
  };

  EventHelper.prototype.clearListeners = function clearListeners(instance) {
    var _this = this;

    var listeners = this._listener.get(instance);
    if (!listeners) return;
    Object.keys(listeners).map(function (eventName) {
      _this.removeListener(instance, eventName);
    });
  };

  return EventHelper;
}();

eventHelper = eventHelper || new EventHelper();

/* harmony default export */ __webpack_exports__["a"] = (eventHelper);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{staticClass:"vue-map"},[_vm._t("map")],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marker_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(2);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marker_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_window_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(2);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_info_window_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polyline_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(2);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polyline_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polygon_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(2);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polygon_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rectangle_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(2);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rectangle_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_circle_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(2);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_circle_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapManager = function () {
  function MapManager() {
    _classCallCheck(this, MapManager);

    this._componentMap = new Map();
    this._map = null;
  }

  MapManager.prototype.setMap = function setMap(map) {
    this._map = map;
  };

  MapManager.prototype.getMap = function getMap() {
    return this._map;
  };

  MapManager.prototype.setComponent = function setComponent(id, component) {
    this._componentMap.set(id, component);
  };

  MapManager.prototype.getComponent = function getComponent(id) {
    return this._componentMap.get(id);
  };

  MapManager.prototype.getChildInstance = function getChildInstance(id) {
    return this.getComponent(id);
  };

  MapManager.prototype.removeComponent = function removeComponent(id) {
    this._componentMap.delete(id);
  };

  return MapManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (MapManager);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js